module.exports = __webpack_public_path__ + "img/图层 1.14ccf84e.png";